document.addEventListener('DOMContentLoaded', function () {

  // ── Sticky ATC ──────────────────────────────────────────────────────────────
  (function initStickyATC() {

    // ── 1. Find the original ATC button (Expanse 9 selectors) ──
    const originalButton = (
      document.querySelector('product-form button[name="add"]') ||
      document.querySelector('product-form [type="submit"]') ||
      document.querySelector('.product-form__submit') ||
      document.querySelector('form[action*="/cart/add"] button[type="submit"]')
    );
    if (!originalButton) return;

    // ── 2. Find product title ──
    const productTitleEl = (
      document.querySelector('.product-meta__title') ||
      document.querySelector('.product__title') ||
      document.querySelector('h1.product-title') ||
      document.querySelector('h1')
    );
    const productTitleText = productTitleEl ? productTitleEl.textContent.trim() : '';

// ── 3. Find selected variant price (Expanse 9 block-price element) ──
const getPriceText = () => {
  // Check if sale price is active
  const saleBlock = document.querySelector('block-price .block-price__sale');
  const regularBlock = document.querySelector('block-price .block-price__regular');

  if (saleBlock) {
    // Get all .element-price spans inside sale block, last one is the actual sale price
    const salePrices = saleBlock.querySelectorAll('.element-price');
    const salePrice = salePrices[salePrices.length - 1];
    if (salePrice && salePrice.textContent.trim()) {
      return salePrice.textContent.trim();
    }
  }

  if (regularBlock) {
    const regularPrice = regularBlock.querySelector('.element-price');
    if (regularPrice && regularPrice.textContent.trim()) {
      return regularPrice.textContent.trim();
    }
  }

  return '';
};

// ── 4b. Find product image ──
const getProductImage = () => {
  // Expanse 9: main product image is a photoswipe image or first standalone image-element
  const imgEl = (
    document.querySelector('.photoswipe__image') ||
    document.querySelector('.product-gallery img.image-element') ||
    document.querySelector('.product-media img.image-element') ||
    document.querySelector('[data-product-media-type-image] img.image-element') ||
    document.querySelector('img.image-element:not(.grid__image-contain)')
  );
  if (!imgEl) return '';

  // Expanse uses srcset with width params — get the src and bump to a small size
  let src = imgEl.src || '';
  // Replace width param with 120 for a small thumbnail
  src = src.replace(/width=\d+/, 'width=120');
  return src;
};

// ── 5. Build the sticky bar HTML ──
const bar = document.createElement('div');
bar.id = 'sticky-atc-bar';
bar.innerHTML = `
  <div class="sticky-atc-inner">
    <div class="sticky-atc-info">
      <div class="sticky-atc-image-wrap">
        <img class="sticky-atc-image" src="" alt="" />
      </div>
      <span class="sticky-atc-name"></span>
    </div>
    <button class="sticky-atc-btn" type="button">
      <span class="sticky-atc-btn-label">Add to cart</span>
      <span class="sticky-atc-divider">|</span>
      <span class="sticky-atc-price"></span>
    </button>
  </div>
`;
document.body.appendChild(bar);

const stickyName  = bar.querySelector('.sticky-atc-name');
const stickyBtn   = bar.querySelector('.sticky-atc-btn');
const stickyPrice = bar.querySelector('.sticky-atc-price');
const stickyLabel = bar.querySelector('.sticky-atc-btn-label');
const stickyImg   = bar.querySelector('.sticky-atc-image');

// ── 6. Populate content ──
const refreshContent = () => {
  stickyName.textContent  = productTitleText;
  stickyPrice.textContent = getPriceText();
  stickyBtn.disabled      = originalButton.disabled;

  // Set image
  const imgSrc = getProductImage();
  if (imgSrc) {
    stickyImg.src = imgSrc;
    stickyImg.style.display = 'block';
  } else {
    stickyImg.style.display = 'none';
  }

  // Reflect loading/sold-out states
  if (originalButton.disabled) {
    stickyLabel.textContent = originalButton.textContent.trim() || 'Sold out';
    stickyPrice.style.display = 'none';
    bar.querySelector('.sticky-atc-divider').style.display = 'none';
  } else {
    stickyLabel.textContent = 'Add to cart';
    stickyPrice.style.display = '';
    bar.querySelector('.sticky-atc-divider').style.display = '';
  }
};

    // ── 7. Show / hide ──
    const setStickyVisible = (visible) => {
      bar.classList.toggle('sticky-atc-visible', visible);
      document.body.classList.toggle('sticky-atc-active', visible);
    };

    const checkVisibility = () => {
      const rect = originalButton.getBoundingClientRect();
      setStickyVisible(rect.bottom < 0);
    };

    new IntersectionObserver(() => checkVisibility(), { threshold: 0 })
      .observe(originalButton);
    window.addEventListener('scroll', checkVisibility, { passive: true });

    // ── 8. Click → trigger real form submit ──
    stickyBtn.addEventListener('click', function () {
      if (!originalButton.disabled) {
        originalButton.click();
      }
    });

    // ── 9. Watch original button for state changes ──
    new MutationObserver(refreshContent).observe(originalButton, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['disabled', 'class']
    });

    // Also watch price element for variant switches
    const priceContainer = document.querySelector('.price-item--regular, [data-product-price], .price');
    if (priceContainer) {
      new MutationObserver(refreshContent).observe(priceContainer, {
        childList: true, subtree: true, characterData: true
      });
    }

    refreshContent();
    checkVisibility();

  })();


  // ── Cart Drawer: lock body scroll ────────────────────────────────────────────
  (function initCartDrawerScrollLock() {

    const cartDrawer = document.querySelector('cart-drawer, [data-cart-drawer]');
    if (!cartDrawer) return;

    const lock   = () => { document.body.style.overflow = 'hidden'; };
    const unlock = () => { document.body.style.overflow = ''; };

    new MutationObserver((mutations) => {
      for (const m of mutations) {
        if (m.attributeName === 'class') {
          const isOpen =
            cartDrawer.classList.contains('is-open') ||
            cartDrawer.classList.contains('active');
          isOpen ? lock() : unlock();
        }
      }
    }).observe(cartDrawer, { attributes: true });

    document.querySelectorAll(
      '.drawer__close, [data-drawer-close], [data-close-drawer]'
    ).forEach(btn => btn.addEventListener('click', unlock));

  })();

});